<div class="header">
  <div class="menu-toggle-wrapper">
    <button class="adap-btn-blank menu-toggle" [matMenuTriggerFor]="menu">
      <mat-icon svgIcon="cvx-hamburger"></mat-icon>
      menu
    </button>
  </div>
  <a class="sitename" [routerLink]="['/']">
    <img alt="chevron logo" class="cvx-img" src="/assets/images/CvxLogo.svg" />
    aftr
  </a>
  <div class="right-header">
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      class="btn-settings"
      matTooltip="settings"
      matTooltipPosition="above"
      matTooltipShowDelay="500"
    >
      <mat-icon>settings</mat-icon>
    </button>
    <mat-menu #menu>
      <a [routerLink]="[GLOBAL_SETTINGS_ROUTE]"
        class="menu-name" 
        mat-menu-item
        target="_blank"
        >
        global settings
      </a>
      <a
        [routerLink]="[GLOBAL_METRICS_ROUTE]"
        class="menu-name"
        mat-menu-item
        *ngIf="isUserDAEngineer"
        target="_blank"
      >
        global metrics
      </a>
    </mat-menu>
    <app-user-button></app-user-button>
  </div>
</div>

<nav class="navigation-bar">
  <ul class="tabs">
    <li class="tab">
      <a
        *ngIf="isUserDAEngineer"
        class="tab-link"
        href="/da-engineer"
        [class.active]="isActive('/da-engineer')"
      >
        engineering management
      </a>
      <a
        *ngIf="isUserChapterManager"
        class="tab-link"
        href="/chapter-manager"
        [class.active]="isActive('/chapter-manager')"
      >
        chapter manager
      </a>
      <a
        *ngIf="isUserSME"
        class="tab-link"
        href="/sme"
        [class.active]="isActive('/sme')"
      >
        SME
      </a>
      <a
        *ngIf="isUserProjectContact"
        class="tab-link"
        href="/project-contact"
        [class.active]="isActive('/project-contact')"
      >
        project contact
      </a>
    </li>
  </ul>
</nav>

<mat-menu #menu="matMenu" class="global-menu-wrapper">
  <app-global-menu></app-global-menu>
</mat-menu>
